import { isMac } from '@/utils/isMac';

export const tableCell = [{ name: 'Клавиши' }, { name: 'Действие' }, { name: 'Категория' }];

export const shortcuts = [
  {
    key: 'T',
    description: 'Открыть полное модальное окно добавления времени',
    category: 'Добавление времени',
  },
  {
    key: '1-7',
    description: 'Открыть быстрое добавление времени для дня недели (1=Пн, 7=Вс)',
    category: 'Добавление времени',
  },
  {
    key: '←, → или ↓',
    description: 'Навигация по неделям (предыдущая/следующая/текущая)',
    category: 'Навигация',
  },
  {
    key: `${isMac ? 'Command(⌘)' : 'Alt'} + Enter`,
    description: 'Сохранить/Добавить/Изменить в окнах',
    category: 'Навигация',
  },
  {
    key: 'Shift + H',
    description: 'Открыть это окно справки',
    category: 'Справка',
  },
  {
    key: 'Shift + T',
    description: 'Открыть окно топ задач',
    category: 'Задачи',
  },
];

export const tips = [
  {
    title: 'Форматы времени',
    description: 'Поддерживаются: 1d, 1h 30m, 90m, 1:30, 1ч 30м, 90м, 1 30, 90, 1д ',
  },
  {
    title: 'Поиск задач',
    description: 'Можно искать по ключу (ABC-123) или названию задачи',
  },
  {
    title: 'Перетаскивание',
    description: 'Логи можно перетаскивать между днями (дублирование/перемещение)',
  },
  {
    title: 'Секундомеры (таймеры)',
    description:
      'На странице «Секундомеры» можно запустить таймер по задаче. По окончании — создать черновик или сразу опубликовать лог в Трекер.',
  },
  {
    title: 'Календарь',
    description:
      'Недельный вид с событиями CalDAV и логами. Можно добавлять лог по клику на время, перетаскивать выделение. Полоска слева у дня: зелёный — время залогировано, красный — встреча без лога.',
  },
  {
    title: 'Черновики по задаче или очереди',
    description:
      'В форме черновика можно указать задачу (например, QUEUE-123) или только очередь (QUEUE). Удобно зафиксировать время до привязки к конкретной задаче.',
  },
];
